import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  Input,
  Renderer2,
} from '@angular/core';

import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropdownOption } from '../dropdown-option.type';

@Component({
  selector: 'ui-dropdown',
  templateUrl: './ui-dropdown.component.html',
  styleUrls: ['./ui-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIDropdownComponent<T> extends DropdownBaseComponent<T> {
  @Input()
  public placeholder: string;

  public selectedOption: DropdownOption<T> | null = null;
  public optionsList: DropdownOption<T>[] = [];

  public constructor(
    injector: Injector,
    renderer: Renderer2,
    elementRef: ElementRef,
    cdr: ChangeDetectorRef,
  ) {
    super(injector, renderer, elementRef, cdr);
  }
}
